var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplelink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1454_512)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.22852,
    y: 2.13159,
    width: 60.3516,
    height: 60.3516,
    rx: 12,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7255 32.6634C44.6881 28.4005 48.1359 26.3266 48.2936 26.23C46.3409 23.3162 43.3144 22.9181 42.2508 22.8863C39.7089 22.6125 37.2432 24.4431 35.9483 24.4431C34.6276 24.4431 32.6336 22.9128 30.4845 22.9577C27.719 23.0014 25.1318 24.6402 23.7129 27.185C20.7846 32.3738 22.9685 39.9989 25.7741 44.1931C27.1775 46.2472 28.8174 48.5407 30.9639 48.46C33.0639 48.3714 33.8483 47.0897 36.3825 47.0897C38.8934 47.0897 39.63 48.46 41.8192 48.4084C44.0729 48.3714 45.4919 46.3451 46.8462 44.2725C48.468 41.9181 49.1193 39.5995 49.1452 39.4805C49.0922 39.4619 44.7682 37.7729 44.7255 32.6634Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1567 20.6204C42.3969 19.2632 43.2455 17.4168 43.0099 15.543C41.2149 15.6125 38.97 16.6295 37.6773 17.9569C36.5336 19.1266 35.5119 21.0439 35.7759 22.8469C37.7923 22.9785 39.8626 21.9566 41.1567 20.6204Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1454_512",
    x: 0.728515,
    y: 0.131592,
    width: 71.3516,
    height: 71.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1454_512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1454_512",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplelink);
export default __webpack_public_path__ + "static/media/applelink.fa0203d8e31cb4fc11843d42c5be629a.svg";
export { ForwardRef as ReactComponent };